/*
 * Copyright 2022-2024 benelog GmbH & Co. KG
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// OpenEPCIS Testdata Generator UI

const getDefaultState = () => ({
  eventCount: 1,
  identifierSyntax: 'URN',
  parentFlag: false,
  instaceIdentifiersModal: false,
  classIdentifiersModal: false,
  identifiersFlagType: '',
  identifiersCounter: 1,
  instanceIdentifiersList: [],
  classIdentifiersList: [],
  outputInstanceIdentifiersList: [],
  outputclassIdentifiersList: [],
  parentIdentifiersList: [],
  currentIdentifiersInfo: {}
})

export default {
  namespaced: true, // 필요하면 추가

  state: getDefaultState,

  mutations: {
    parentFlagToggle(state) {
      state.parentFlag = !state.parentFlag
    },
    resetIdentifiersData(state) {
      state.identifiersCounter = 1
      state.instanceIdentifiersList = []
      state.classIdentifiersList = []
      state.outputInstanceIdentifiersList = []
      state.outputclassIdentifiersList = []
      state.parentIdentifiersList = []
    },
    populateEventCount(state, eventCount) {
      state.eventCount = eventCount
    },
    populateIdentifiersType(state, payload) {
      state.identifierSyntax = payload.identifierSyntax
    },
    showInstanceIdentifiersModal(state) {
      state.instaceIdentifiersModal = true
    },
    hideInstanceIdentifiersModal(state) {
      state.instaceIdentifiersModal = false
    },
    populateInstanceIdentifiers(state, instanceIdentifiersList) {
      state.instanceIdentifiersList = instanceIdentifiersList
    },
    showClassIdentifiersModal(state) {
      state.classIdentifiersModal = true
    },
    hideClassIdentifiersModal(state) {
      state.classIdentifiersModal = false
    },
    saveInstanceIdentifiersInformation(state, payload) {
      if (state.instanceIdentifiersList.length > 0) {
        state.instanceIdentifiersList = []
      }
      const instanceIdentifierObj = {
        ID: state.identifiersCounter,
        name: 'EPC : ' + state.identifiersCounter,
        type: payload.instanceData.identifierType
      }
      instanceIdentifierObj[payload.instanceData.identifierType] = payload.instanceData
      state.instanceIdentifiersList.push(instanceIdentifierObj)
      state.identifiersCounter++
      state.currentIdentifiersInfo = {}
    },
    deleteInstnaceIdentifiersInformation(state, payload) {
      if (payload.flagType === 'TransformationEventOutputEPC') {
        state.outputInstanceIdentifiersList.splice(state.outputInstanceIdentifiersList.findIndex(obj => obj.ID === payload.instanceID), 1)
      } else {
        state.instanceIdentifiersList.splice(state.instanceIdentifiersList.findIndex(obj => obj.ID === payload.instanceID), 1)
      }
    },
    saveClassIdentifiersInformation(state, payload) {
      if (state.classIdentifiersList.length > 0) {
        state.classIdentifiersList = []
      }
      const classIdentifierObj = {
        ID: state.identifiersCounter,
        name: 'Quantity : ' + state.identifiersCounter,
        type: payload.classData.identifierType
      }
      classIdentifierObj[payload.classData.identifierType] = payload.classData
      state.classIdentifiersList.push(classIdentifierObj)
      state.identifiersCounter++
      state.currentIdentifiersInfo = {}
    },
    deleteClassIdentifiersInformation(state, payload) {
      if (payload.flagType === 'TransformationEventOutputQuantity') {
        state.outputclassIdentifiersList.splice(state.outputclassIdentifiersList.findIndex(obj => obj.ID === payload.classId), 1)
      } else {
        state.classIdentifiersList.splice(state.classIdentifiersList.findIndex(obj => obj.ID === payload.classId), 1)
      }
    },
    populateIdentifiersFlagType(state, flagType) {
      state.identifiersFlagType = flagType
    },
    saveoutputInstanceIdentifiersInformation(state, payload) {
      if (state.outputInstanceIdentifiersList.length > 0) {
        state.outputInstanceIdentifiersList = []
      }
      const instanceIdentifierObj = {
        ID: state.identifiersCounter,
        name: 'Output EPC : ' + state.identifiersCounter,
        type: payload.instanceData.identifierType
      }
      instanceIdentifierObj[payload.instanceData.identifierType] = payload.instanceData
      state.outputInstanceIdentifiersList.push(instanceIdentifierObj)
      state.identifiersCounter++
      state.currentIdentifiersInfo = {}
    },
    deleteOutputInstanceIdentifiersInformation(state, payload) {
      state.outputInstanceIdentifiersList.splice(state.outputInstanceIdentifiersList.findIndex(obj => obj.ID === payload.instanceID), 1)
    },
    saveoutputclassIdentifiersInformation(state, payload) {
      if (state.outputclassIdentifiersList.length > 0) {
        state.outputclassIdentifiersList = []
      }
      const classIdentifierObj = {
        ID: state.identifiersCounter,
        name: 'Output Quantity : ' + state.identifiersCounter,
        type: payload.classData.identifierType
      }
      classIdentifierObj[payload.classData.identifierType] = payload.classData
      state.outputclassIdentifiersList.push(classIdentifierObj)
      state.identifiersCounter++
      state.currentIdentifiersInfo = {}
    },
    deleteOutputClassIdentifiersInformation(state, payload) {
      state.outputclassIdentifiersList.splice(state.outputclassIdentifiersList.findIndex(obj => obj.ID === payload.classId), 1)
    },
    saveParentIdentifiersInformation(state, payload) {
      if (state.parentIdentifiersList.length > 0) {
        state.parentIdentifiersList = []
      }
      const instanceIdentifierObj = {
        ID: state.identifiersCounter,
        name: 'Parent ID : ' + state.identifiersCounter,
        type: payload.instanceData.identifierType
      }
      instanceIdentifierObj[payload.instanceData.identifierType] = payload.instanceData
      state.parentIdentifiersList.push(instanceIdentifierObj)
      state.identifiersCounter++
      state.currentIdentifiersInfo = {}
    },
    deleteParentIdentifiersInformation(state, payload) {
      state.parentIdentifiersList = []
    },
    generateInstanceIdentifiers(state, inputData) {
      state.epc = inputData
    },
    modifyInstanceIdentifiersInformation(state, payload) {
      if (payload.flagType === 'TransformationEventOutputEPC') {
        state.currentIdentifiersInfo = state.outputInstanceIdentifiersList.find(idNode => idNode.ID === payload.instanceID)
      } else {
        state.currentIdentifiersInfo = state.instanceIdentifiersList.find(idNode => idNode.ID === payload.instanceID)
      }
    },
    modifyParentIdentifiersInformation(state, payload) {
      state.currentIdentifiersInfo = state.parentIdentifiersList.find(idNode => idNode.ID === payload.parentId)
    },
    modifyClassIdentifiersInformation(state, payload) {
      if (payload.flagType === 'TransformationEventOutputQuantity') {
        state.currentIdentifiersInfo = state.outputclassIdentifiersList.find(idNode => idNode.ID === payload.classId)
      } else {
        state.currentIdentifiersInfo = state.classIdentifiersList.find(idNode => idNode.ID === payload.classId)
      }
    },
    resetCurrentIdentifiersInfo(state) {
      state.currentIdentifiersInfo = {}
    },
    populateRawData(state, payload) {
      state.instanceIdentifiersList = payload.epc
      state.classIdentifiersList = payload.quantity
      state.outputInstanceIdentifiersList = payload.outputEpc
      state.outputclassIdentifiersList = payload.outputQuantity
      state.parentIdentifiersList = payload.parentID

      state.instanceIdentifiersCount = state.instanceIdentifiersList.length > 0 ? state.instanceIdentifiersList.at(-1).ID + 1 : 0
      state.classIdentifiersCount = state.classIdentifiersList.length > 0 ? state.classIdentifiersList.at(-1).ID + 1 : 0
      state.outputInstanceIdentifiersCount = state.outputInstanceIdentifiersList.length > 0 ? state.outputInstanceIdentifiersList.at(-1).ID + 1 : 0
      state.outputClassIdentifiersCount = state.outputclassIdentifiersList.length > 0 ? state.outputclassIdentifiersList.at(-1).ID + 1 : 0
    }
  }
}
